var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_vm._l((_vm.fileFontStyles),function(style,index){return _c('v-style',{key:("font-" + index)},[_vm._v(_vm._s(style))])}),_c('RouterView',{key:_vm.$route.fullPath})],2)}
var staticRenderFns = []

export { render, staticRenderFns }